import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'API and Сonnectivity',
                topics: [
                    'Headless and API-driven eCommerce',
                    'SaaS Shopping Carts',
                    'Composable Commerce',
                ],
            },
            {
                title: 'Database',
                topics: [
                    'Designing the database and identifying the functionalities offered by the ecommerce platform',
                    'How to Use Database Integration in eCommerce?',
                ],
            },
            {
                title: 'eCommerce Essentials',
                topics: [
                    'eCommerce & Core Web Vitals',
                    'Increasing Reliability on Advanced Blockchain Systems',
                    'Securing the Shop Against Emerging Threats',
                ],
            },
            {
                title: 'Cloud Computing',
                topics: [
                    'Containers, Serverless, and Scaling',
                    'Cloud security, privacy, and compliance',
                    'Cloud Migration Strategies',
                ],
            },
            {
                title: 'Architecture',
                topics: [
                    'Microservices',
                    'Modular Architecture',
                    'System Integration and Infrastructure',
                ],
            },
            {
                title: 'CRM',
                topics: [
                    'AI and Fraud Prevention in eCommerce',
                    'Scaling the infrastructure to handle large traffic',
                ],
            },
            {
                title: 'Major CMS updates',
                topics: [
                    'Create customer-centric search',
                    'AI and Pricing in Ecommerce',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <p className='getReady_item--title'>{item.title}</p>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li key={`getReady_li-${i + item}`} className='getReady_li'>{item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_arrows'>
            <div className='getReady_wrap black'>
                <div className='container getReady'>
                    <h2 className='getReady_title'>What event <span className='title_gradient'>is</span> about</h2>
                    <div className='getReady_block'>
                        {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Event_about;